// extracted by mini-css-extract-plugin
export default {"btn__container":"TeamBTN_btn__container__8GN+a","team__icon":"TeamBTN_team__icon__QM1Ob"};